<div class="c-avatar_info color-white">
  <ng-container>
    <button mat-button class="color-white font-14 u-capitalize outline-none" [matMenuTriggerFor]="menu"
      id="notify_button" tabindex="0" (click)="clickButtonNotification()" aria-label="Notificaciones">
      <div class="container-badge-alert">
        <img src="assets/images/bell.png" alt="bell" class="bell-icon">
        <img *ngIf="counterRequestDefault" src="assets/images/alert.png"
          alt="Badge Notificaciones" class="custom-badge-alert-notiffty">
      </div>
    </button>
  </ng-container>

  <mat-menu #menu="matMenu">
    <div class="padding-box">
      <h4>Notificaciones</h4>
      <hr>
      <ul>
        <!-- Notificación de Solicitudes Pendientes -->
        <li *ngIf="counterRequestDefault">
          <div class="container-message-badge">
            <img src="assets/images/highlight.png" alt="notifications" class="custom-badge-notify">
            <div class="container-message-notify">
              <a appDebounceClick
                [analyticsModel]="{'event':'ga_event','category':'Titulo Notificaciones','action':'clic_notificacion','label':'Notificaciones'}"
                (click)="goToNewsDefault(true)" class="text-underline" id="notification-solicitudes"
                aria-label="Tienes ajustes pendientes en el listado de tus solicitudes">
                <span class="notify-message-text" aria-hidden="true">
                  Tienes ajustes pendientes en el listado de tus solicitudes
                </span>
              </a>
            </div>
          </div>
        </li>

        <!-- Mensaje cuando no hay notificaciones -->
        <li *ngIf="!counterRequestDefault">
          <div class="container-message-notify">
            <span class="notify-message-text" id="message-notify-empty" aria-hidden="true">
              No tienes notificaciones en este momento
            </span>
          </div>
        </li>
      </ul>
    </div>
  </mat-menu>
</div>

<app-popup-solicitudes-pendientes
  [idModal]="popupSolicitudesId"
  [textDescription]="'Tienes ajustes pendientes en el listado de tus solicitudes'"
  (irASolicitudes)="irASolicitudesPendientes($event)">
</app-popup-solicitudes-pendientes>
